import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Layout } from '@stashinvest/ui';
import { getURLParam } from 'stash/utils/urls';
import { getCookie, setCookie } from 'stash/utils/cookies';
import { getUserByUUID, postTokenRequest } from 'stash/actions';
import LoginRoute from 'stash/routes/SessionManagementRoutes/LogInRoute';
import ErrorMessageComponent from 'stash/components/error-boundary/ErrorMessageComponent';
import { useHistory } from 'react-router-dom';
import { DEVICE_ID_COOKIE_NAME } from '../../constants/session';
import { track } from 'stash/hooks/useTrack';
import { v1_HodorVerification_Succeeded } from '@stashinvest/product-events-javascript/lib/v1/event_static_methods';

const checkStateParam = () => {
	const state = getURLParam('state');
	const stateCookie = getCookie('AUTH_STATE_PARAM');
	if (!state || !stateCookie) {
		return false;
	}
	return state === stateCookie;
};

const mapDispatchToProps = { postTokenRequest, getUserByUUID };
const mapStateToProps = (state) => {
	return {
		access_token: state.entities?.api_key?.access_token,
		uuid: state.entities?.api_key?.uuid,
		email: state.entities?.user?.email,
	};
};

const AuthorizeRoute = ({
	access_token,
	postTokenRequest,
	uuid,
	getUserByUUID,
	email,
}) => {
	const [invalid, setInvalid] = useState(false);
	const [error, setError] = useState(false);
	const history = useHistory();

	useEffect(() => {
		if (getURLParam('error')) {
			setError(true);
		} else {
			const code = getURLParam('code');
			if (code && checkStateParam()) {
				const deviceId = getURLParam('known_device_id');
				if (deviceId) {
					setCookie(DEVICE_ID_COOKIE_NAME, deviceId);
				}
				if (!access_token) {
					const codeVerifier = getCookie('AUTH_CODE_VERIFIER');
					postTokenRequest(code, codeVerifier);
				}
			} else {
				setInvalid(true);
			}
		}
	}, [access_token, postTokenRequest]);

	useEffect(() => {
		if (access_token && uuid) {
			getUserByUUID();
		}
	}, [access_token, uuid, getUserByUUID]);

	useEffect(() => {
		if (access_token && email) {
			const sessionType = getURLParam('session_type');
			const redirect = getURLParam('r') || '/';
			setCookie('AUTH_SESSION_TYPE', sessionType);

			try {
				track(
					v1_HodorVerification_Succeeded({
						origin: sessionType.toLowerCase(),
					})
				);
			} catch (e) {
				console.error('Error tracking HodorVerification_Succeeded event', e);
			}

			history.replace(redirect);
		}
	}, [access_token, email, history]);
	if (error) {
		return <ErrorMessageComponent />;
	}
	if (invalid) {
		return <LoginRoute />;
	}
	return <Layout.PageWrapLoader />;
};

AuthorizeRoute.propTypes = {
	access_token: PropTypes.string,
	postTokenRequest: PropTypes.func,
	uuid: PropTypes.string,
	getUserByUUID: PropTypes.func,
	email: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthorizeRoute);
